import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { Link } from "react-router-dom";

import { Row, Col, FullRow } from "../../framework/Grid/";
import { map } from "lodash";
import { Dialog, FlatButton } from "material-ui";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { buttonBlueColor } from "../../../utils/utility";

class HtmlTagDetail extends AcquireWebComponent {
  componentWillMount() {
    this.state = {
      showImgTagDialog: false,
      imgTag: this.props.imgTag,
      imgTagFilename: this.props.imgTagFileName,
      imgTagName: this.props.imgTagName,
    };
  }

  _downloadTxtFile = (fileName, txt) => {
    var element = document.createElement("a");
    var file = new Blob([txt], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    //element.download = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
    // 										+ "_Tag_JS.txt"
    element.download = fileName;
    element.click();
  };

  _downloadImageTagTextFile = () => {
    const { imgTag, imgTagFilename } = this.state;
    if (imgTag) {
      var element = document.createElement("a");
      var file = new Blob([imgTag], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      //element.download = this.props.website_name ? this.props.website_name : this.props.tag_info.siteName
      //										 + "_Tag_IMG.txt"
      element.download = imgTagFilename;
      element.click();
    }
  };

  render() {
    const imgTagActions = [
      <FlatButton
        key="1"
        label="Cancel"
        primary={true}
        className="black-border btn-aa-info"
        backgroundColor={"#FFFFFF"}
        labelStyle={{ color: "#000" }}
        hoverColor={"#FFFFFF"}
        onClick={() => {
          this.setState({ showImgTagDialog: false });
        }}
      />,
      <div key="2" style={{ flexGrow: "1" }}></div>,
      <button
        key="3"
        type="button"
        style={{ height: "36px", marginRight: "10px" }}
        className="btn btn-default legitRipple btn-aa-default ml-10 pull-right"
      >
        <a
          href="https://s3-us-west-2.amazonaws.com/images.audience-anywhere.com/Claritas_Insights_Tag_Implementation_Guide.pdf"
          target="_blank"
        >
          DOWNLOAD IMPLEMENTATION GUIDE
        </a>
      </button>,
      <FlatButton
        key="4"
        label="Download AS TEXT FILE"
        primary={true}
        className="pull-right btn btn-default legitRipple btn-aa-default"
        backgroundColor={buttonBlueColor()}
        labelStyle={{ color: "#FFF" }}
        hoverColor={buttonBlueColor()}
        onClick={() => this._downloadImageTagTextFile()}
      />,
    ];
    const { type, clientName, buName } = this.props;
    const {
      tagParams,
      jsTagTemplate,
      imageTagTemplate,
      dynamic,
      id,
      jsTag,
      imageTag,
      deploymentType,
    } = this.props.tag_info;
    const tagType = deploymentType === "Web" ? "Web Deployment" : "HTML Email";
    // const showPrimary = tagParams && !isNil(tagParams.pageReferences) ?
    // 	dynamic === true && (!isEmpty(tagParams.pageReferences)) :
    // 	(tagParams && !isNil(tagParams.passThroughs) && !isEmpty(tagParams.passThroughs)) ||
    // 	(tagParams && !isNil(tagParams.hashedEmails) && !isEmpty(tagParams.hashedEmails))

    const primaryJsTag = jsTag;
    const filePreName = this.props.website_name
      ? this.props.website_name
      : this.props.tag_info.siteName;
    const primaryJsTagFileName = (filePreName + "_Tag_JS.txt").replace(
      " ",
      "_",
    );
    const primaryImgTag = imageTag;
    const primaryImgTagFileName = (filePreName + "_Tag_IMG.txt").replace(
      " ",
      "_",
    );
    return (
      <div
        style={this.props.style ? this.props.style : { padding: "20px 10%" }}
        key="tag-create-confirm"
      >
        <div>
          <Row className="no-padding no-margin-bottom">
            <Col xs="6" sm="6" md="6" lg="6">
              <a
                className="aa-color"
                onClick={e => {
                  this.props.backToListClick(e);
                }}
              >
                Tags
              </a>
              &nbsp;&nbsp;&nbsp;>&nbsp;&nbsp;&nbsp;Insights Tag{" "}
              {type === "detail" ? "Detail" : "Creation"}
            </Col>
            <Col xs="6" sm="6" md="6" lg="6" className="text-right">
              {parseInt(this.props.roleId, 10) === 1 && (
                <Link
                  to={"/settings/tags/edit?id=" + id}
                  className="btn-aa-default"
                >
                  EDIT TAG
                </Link>
              )}
            </Col>
          </Row>
        </div>
        <div
          className="black-border no-padding mt-20"
          style={{ fontWeight: 300, background: "#FFF" }}
        >
          <FullRow style={{ fontSize: "12pt" }} className="no-padding-bottom">
            <strong>
              INSIGHTS TAG {type === "detail" ? "DETAIL" : "CREATION"}
            </strong>
          </FullRow>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Client Name</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {clientName}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Business Unit Name</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {buName}
            </Col>
          </Row>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Tag Deployment Type</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {tagType}
            </Col>
          </Row>
          <Row
            className="no-padding-top no-padding-bottom mb-20"
            style={{ display: deploymentType === "Web" ? "block" : "none" }}
          >
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Website Name</strong>
              <span style={{ color: "red" }}>*</span>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.website_name
                ? this.props.website_name
                : this.props.tag_info.siteName}
            </Col>
          </Row>
          <Row
            className="no-padding-top no-padding-bottom "
            style={{ display: deploymentType === "Web" ? "block" : "none" }}
          >
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Website Domain</strong>
              <span style={{ color: "red" }}>*</span>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.website_url
                ? this.props.website_url
                : this.props.tag_info.domain}
            </Col>
          </Row>
          <FullRow className="no-padding-top no-padding-bottom ">
            <hr className="black-hr" />
          </FullRow>
          <Row className="no-padding-top no-padding-bottom mb-20">
            <Col xs="3" sm="3" md="3" lg="3">
              <strong>Insights Tag ID</strong>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8">
              {this.props.tag_info ? this.props.tag_info.uuid : ""}
            </Col>
          </Row>
          <FullRow className="no-padding-top no-padding-bottom mb-20">
            Below are your insights tacking code(s) based on the criteria you
            entered. Please note, we will always provide you a primary tag that
            can be deployed site wide and will collect site and page level
            information. <br />
            <br />
            If you selected page reference custom variables and depending on the
            delivery method you selected, you will also find below either an
            updated primary tag or unique insights tag(s) for each page
            reference you created.
            <br />
            <br />
            Copy and Paste the primary tag code below between the {
              "<head>"
            } and {"</head>"} tags of every webpage you want to track.
            Similarly, Copy and Paste the page reference tag(s) between the{" "}
            {"<head>"} and {"</head>"} tags of every webpage you want to the
            page reference tag to track.
            <br />
            <br />
            Please note, if your site uses a "Master Page" or master template,
            the primary tag script can be placed there to appear on all pages.
            You may already have other existing code between the head tags, so
            just place the pixel code underneath that, but above {"</head>"}.
          </FullRow>
          <FullRow className="no-padding-top no-padding-bottom mb-20">
            <strong>
              Implementing the Insight Tag with an Exiting Tag Manager
            </strong>
          </FullRow>
          <FullRow className="no-padding-top no-padding-bottom mb-20">
            The Insights tag can be easilly implemented with a Tag Manager such
            as Google Tag Manager or others. When creating a new tag within your
            tag manager, select Custom HTML Tag and COPY and PASTE your unique
            Insight tag and assign it to all pages, or select a specific page.
          </FullRow>
          <FullRow className="no-padding-top no-padding-bottom mb-20 text-right">
            <button
              type="button"
              className="btn btn-default legitRipple btn-aa-default ml-20"
            >
              <a
                href="https://s3-us-west-2.amazonaws.com/images.audience-anywhere.com/Claritas_Insights_Tag_Implementation_Guide.pdf"
                target="_blank"
              >
                DOWNLOAD IMPLEMENTATION GUIDE
              </a>
            </button>
          </FullRow>
          <FullRow className="no-padding-top no-padding-bottom pl-10 pr-10 mb-20 ml-20 mr-20 black-border">
            <FullRow className="no-padding mt-20 mb-10">
              <strong>PRIMARY JAVASCRIPT TAG</strong>
            </FullRow>
            <Row className="no-padding no-margin-bottom">
              <Col xs="8" sm="8" md="8" lg="8">
                <a
                  className="aa-color"
                  onClick={e => {
                    e.preventDefault();
                    this.setState({
                      showImgTagDialog: true,
                      imgTag: primaryImgTag,
                      imgTagFilename: primaryImgTagFileName,
                      imgTagName: "PRIMARY",
                    });
                  }}
                >
                  Click here
                </a>{" "}
                if a non javascript tag is required
              </Col>
              <Col
                xs="4"
                sm="4"
                md="4"
                lg="4"
                style={{ textAlign: "right" }}
              ></Col>
            </Row>
            <FullRow className="no-padding no-margin-bottom">
              <hr style={{ borderColor: "#000" }} />
            </FullRow>
            <FullRow className="no-padding no-margin-bottom">
              <textarea
                id="js-code-box"
                value={primaryJsTag}
                readOnly
                style={{
                  width: "100%",
                  height: "200px",
                  border: "none",
                  overflow: "hidden",
                }}
              />
            </FullRow>
            <FullRow className="no-padding no-margin-bottom">
              <hr style={{ borderColor: "#000" }} />
            </FullRow>
            <FullRow className="text-right no-padding mb-20">
              <button
                type="button"
                className="btn btn-default legitRipple btn-aa-default mr-10"
                onClick={e => {
                  e.preventDefault();
                  this._downloadTxtFile(primaryJsTagFileName, primaryJsTag);
                }}
              >
                DOWNLOAD AS TEXT FILE
              </button>
              <CopyToClipboard
                text={primaryJsTag}
                onCopy={() => this.setState({ copied: true })}
              >
                <button
                  type="button"
                  className="btn btn-default legitRipple btn-aa-default"
                >
                  Copy tag to clipboard
                </button>
              </CopyToClipboard>
            </FullRow>
          </FullRow>
          {tagParams &&
            dynamic === false &&
            map(tagParams.pageReferences, r => {
              const imgTag = imageTagTemplate.replace("##Page_Ref##", r);
              const jsTag = jsTagTemplate.replace("##Page_Ref##", r);
              const filePreName = this.props.website_name
                ? this.props.website_name
                : this.props.tag_info.siteName;
              const jsFileName = (
                filePreName +
                "_" +
                r +
                "_Tag_JS.txt"
              ).replace(" ", "_");
              const imgTagFileName = (
                filePreName +
                "_" +
                r +
                "_Tag_IMG.txt"
              ).replace(" ", "_");
              return (
                <FullRow
                  key={`page-reference-${r}-container`}
                  className="no-padding-top no-padding-bottom pl-10 pr-10 mb-20 ml-20 mr-20 black-border"
                >
                  <FullRow className="no-padding mt-20 mb-10">
                    <strong>PAGE REFERENCE JAVASCRIPT TAG: {r}</strong>
                  </FullRow>
                  <Row className="no-padding no-margin-bottom">
                    <Col xs="8" sm="8" md="8" lg="8">
                      <a
                        className="aa-color"
                        onClick={e => {
                          e.preventDefault();
                          this.setState({
                            showImgTagDialog: true,
                            imgTag: imgTag,
                            imgTagFilename: imgTagFileName,
                            imgTagName: r.toUpperCase(),
                          });
                        }}
                      >
                        Click here
                      </a>{" "}
                      if a non javascript tag is required
                    </Col>
                    <Col
                      xs="4"
                      sm="4"
                      md="4"
                      lg="4"
                      style={{ textAlign: "right" }}
                    >
                      &nbsp;
                    </Col>
                  </Row>
                  <FullRow className="no-padding no-margin-bottom">
                    <hr style={{ borderColor: "#000" }} />
                  </FullRow>
                  <FullRow className="no-padding no-margin-bottom">
                    <textarea
                      id="js-code-box"
                      value={jsTag}
                      readOnly
                      style={{
                        width: "100%",
                        height: "200px",
                        border: "none",
                        overflow: "hidden",
                      }}
                    />
                  </FullRow>
                  <FullRow className="no-padding no-margin-bottom">
                    <hr style={{ borderColor: "#000" }} />
                  </FullRow>
                  <FullRow className="text-right no-padding mb-20">
                    <button
                      type="button"
                      className="btn btn-default legitRipple btn-aa-default mr-10"
                      onClick={e => {
                        e.preventDefault();
                        this._downloadTxtFile(jsFileName, jsTag);
                      }}
                    >
                      DOWNLOAD AS TEXT FILE
                    </button>
                    <CopyToClipboard
                      text={jsTag}
                      onCopy={() => this.setState({ copied: true })}
                    >
                      <button
                        type="button"
                        className="btn btn-default legitRipple btn-aa-default"
                      >
                        Copy tag to clipboard
                      </button>
                    </CopyToClipboard>
                  </FullRow>
                </FullRow>
              );
            })}
          <Row className="no-padding ml-20 mr-20 mb-20 text-right">
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              className="text-right no-padding"
            >
              <a
                className="aa-color"
                onClick={e => {
                  this.props.backToListClick(e);
                }}
              >
                Back to Tags
              </a>
            </Col>
          </Row>
          <Dialog
            actions={imgTagActions}
            title={this.state.imgTagName + " IMAGE TAG"}
            contentStyle={{
              color: "rgba(0,0,0,1)",
              minHeight: "100px",
              paddingBottom: "0px",
              minWidth: "680px",
              paddingBotom: "0px",
              maxWidth: "800px",
              maxHeight: "none",
              fontWeight: "bold",
            }}
            modal={false}
            open={this.state.showImgTagDialog}
            titleStyle={{
              fontSize: "12pt",
              paddingBottom: "0px",
              paddingTop: "10px",
            }}
            actionsContainerStyle={{
              textTransform: "uppercase",
              textAlign: "center",
              paddingBottom: "24px",
              paddingLeft: "24px",
              paddingRight: "24px",
              display: "flex",
            }}
          >
            <CopyToClipboard
              text={this.state.imgTag}
              style={{ height: "40px" }}
              onCopy={() => this.setState({ copied: true })}
            >
              <button
                type="button"
                style={{ margintTop: "-10px" }}
                className="btn btn-default legitRipple btn-aa-default pull-right"
              >
                Copy tag to clipboard
              </button>
            </CopyToClipboard>
            <hr style={{ borderColor: "#000", marginTop: "50px" }} />
            <FullRow className="no-padding">
              <span style={{ color: "#F56600" }}>PLEASE NOTE: </span>Image Tags
              require additional parameter configuration. If you are using a Tag
              Manager, please refer to the documentation. For a list of
              available parameters please refer to the Implementation Guide.
            </FullRow>
            <FullRow className="no-padding mb-20">
              <hr className="no-margin" style={{ borderColor: "#000" }} />
            </FullRow>
            <textarea
              id="img-code-box"
              value={this.state.imgTag}
              readOnly
              style={{
                fontSize: "10pt",
                color: "#000",
                fontWeight: "300",
                width: "100%",
                height: "60px",
                border: "none",
                overflow: "hidden",
              }}
            />
            <hr
              style={{
                borderColor: "#000",
                marginTop: "0px",
                marginBottom: "0px",
              }}
            />
          </Dialog>
        </div>
      </div>
    );
  }
}

export default HtmlTagDetail;



// WEBPACK FOOTER //
// ./src/components/Insights/tags/HtmlTagDetail.jsx